import NiDivider from "../divider"
export default {
  components:{
    NiDivider
  },
  props: {
    enable: {
      type: Boolean,
      default: true
    },
    button_style: {
      type: Object,
      default() {
        return {}
      }
    },
    text: null,
    icon: null,
    show_title: {
      type: String,
      default: ""
    },
    //是否要竖线
    isLine: {
      type: Boolean,
      default: false
    },
    underline: {
      type: Boolean,
      default: false
    },

    icon_style: {
      type: Object,
      default() {
        return {
          transform: 'translateY(2px)'
        }
      }
    },

    btn_loading: {
      type: Boolean,
      default: false
    },

    is_colored:{
      type: Boolean,
      default: false
    },

  },
  computed: {
    enabled_class() {
      let enable = this.enable
      return {
        org_img_block_enable: enable,
        "mask-class": !enable
      }
    },

    is_enabled(){
      if (this.btn_loading){
        return false;
      }
      return this.enable;
    },

  },
  methods: {
    nClick() {
      if(!this.enable || this.btn_loading){
        return
      }
      this.$emit("click")
    }
    // 选中不选中样式控制

  }
}



// WEBPACK FOOTER //
// ./src/ni-ui/button/button.js